import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitSummary } from '../../../../../../models/submissions/variable-benefit-summary';

@Component({
  selector: 'app-vb-payment-change-deposit-instructions',
  templateUrl: './vb-payment-change-deposit-instructions.component.html',
  styleUrls: ['./vb-payment-change-deposit-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeDepositInstructionsComponent {
  @Input({ required: true }) summary!: VariableBenefitSummary | null;
}
